<div class="header-section">
  <div class="title-section">
    <h3 class="same-line">{{sharedDataContent.preview_table.title}}</h3>
  </div>
</div>

<div class="audit-details-section">
  <div class="content-panel">
    <div class="detail-section">
      <div class="table-header-section">
        <div class="summary-tile">
          @for (summary of fileSummary; track summary) {
            <mat-card class="summary-card">
              <div class="summary-card-body">
                <span class="summary-card-sub">{{summary.header}}</span>
                <span class="summary-card-value">{{summary.value}}</span>
              </div>
            </mat-card>
          }
          <mat-card class="summary-card">
            <div class="summary-card-body">
              <span class="summary-card-sub">{{sharedDataContent.file_summary.download_report}}</span>
              <span class="summary-card-value"><mat-icon (click)="exportFile()" class="export-icon">cloud_download</mat-icon></span>
            </div>
          </mat-card>
        </div>
        <div class="filter-section">
          <input matInput (keyup)="applyFilter($event.target.value)" placeholder="search" class="cus-input mat-mdc-input-element">
          <mat-icon class="search-product-icon">search</mat-icon>
        </div>
      </div>
      <div class="preview-table-responsive">
        <table mat-table #table [dataSource]="dataSource" class="preview-table-responsive table-striped">
          @for (cols of headerColumns; track cols) {
            <ng-container [matColumnDef]="cols" [stickyEnd]="cols === 'Remarks'">
              <th mat-header-cell *matHeaderCellDef [attr.colspan]="lengthCheck(cols)"
                [class.stickyColumn]="cols === 'Remarks'" [style.color]="cols === 'Remarks' ? 'transparent': ''"
              >{{cols | transformTitle}}</th>
            </ng-container>
          }
          @for (subHeader of subHeaderColumns; track subHeader) {
            <ng-container [matColumnDef]="subHeader" [stickyEnd]="!showRemarks(subHeader)">
              <th mat-header-cell *matHeaderCellDef
                class="sub-header" [class.stickyColumn]="!showRemarks(subHeader)"
              >{{subHeader| removeDoubleUnderscore | transformTitle}}</th>
              <td mat-cell *matCellDef="let element" [style.text-align]="!showRemarks(subHeader) ? 'center': ''">
                @if (hasError(element,subHeader, 'partnerId')) {
                  <mat-icon class="error-icon">error</mat-icon>
                }
                @if (showRemarks(subHeader)) {
                  <div class="preview-data-section">
                    <input [type]="getInputFieldTypes(element,subHeader)" #inputValue matInput value="{{showData(element,subHeader)}}"
                      (input)="updateValue($event,element,subHeader)" (focusin)="checkIsValueIsEdited()" (focusout)="checkISValueIsDeleted(showData(element,subHeader))"
                      [class.btnAvail]="updatedValue">
                    @if (!(showData(element,subHeader) === null && inputValue.value.length === 0)) {
                      <div class="preview-data-actions">
                        <mat-icon matSuffix class="save" aria-label="save" (click)="saveOrCancelUpdatedValue('save',inputValue.value,subHeader)">check_circle</mat-icon>
                        <mat-icon matSuffix class="cancel" aria-label="cancel" (click)="saveOrCancelUpdatedValue('cancel',inputValue.value,subHeader)">cancel</mat-icon>
                      </div>
                    }
                  </div>
                }
                @if (!showRemarks(subHeader)) {
                  <mat-icon [class.disable-validate-icon]="!hasError(element,subHeader, 'Remarks')"
                  (click)="viewRemarks(element,subHeader,'Remarks')" class="view-icon"  matTooltip="view remarks">visibility</mat-icon>
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="headerColumns; sticky: true"></tr>
          <tr mat-header-row *matHeaderRowDef="subHeaderColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: subHeaderColumns;" class="preview-data-row"></tr>
        </table>
      </div>
      <mat-paginator #paginatorRef [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div>
</div>
<div class="actions-buttons">
  <button mat-button (click)="cancelMigrationFromPreview()" class="next-btn">{{sharedDataContent.buttons_list.cancel_migration}}</button>
  <button mat-button (click)="gotoNextStep()" class="next-btn" [disabled]="errorState">Continue</button>
  <button mat-button (click)="retryOrIgnoreDataValidation('retry')"
  [disabled]="compareJSONObjects(tableData,tempTableData)" class="next-btn">Revalidate</button>
</div>

<ng-template #viewRemarksDialog>
  <h2 mat-dialog-title>Remarks</h2>
  <div mat-dialog-content>
    <div class="">
      @for (remark of remarksDialogContent; track remark) {
        <div class="remarks-list">
          <mat-icon>error</mat-icon>
          <span>{{remark}}</span>
        </div>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
  </div>
</ng-template>


<ng-template #showSaveAndCancelDialog>
  <h2 mat-dialog-title>Save Changes?</h2>
  <div mat-dialog-content>
    Do you want to save the changes?
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="dialogRef.close('save')">Save</button>
    <button mat-button (click)="dialogRef.close('cancel')">Discard</button>
  </div>
</ng-template>

<ng-template #migrationDialogPreview>
  <h2 mat-dialog-title>Cancel Migration!</h2>
  <div mat-dialog-content>
    Are you sure you want to cancel the migration process?
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="cancelMigrationOnPreview()">OK</button>
    <button mat-button mat-dialog-close>CANCEL</button>
  </div>
</ng-template>